export default __webpack_public_path__ + "static/media/GI.a87ba99e.svg";